import { render, staticRenderFns } from "./ViewClienteContactoInfo.vue?vue&type=template&id=50b99ab8&scoped=true&"
import script from "./ViewClienteContactoInfo.vue?vue&type=script&lang=js&"
export * from "./ViewClienteContactoInfo.vue?vue&type=script&lang=js&"
import style0 from "./ViewClienteContactoInfo.vue?vue&type=style&index=0&id=50b99ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b99ab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
